module.exports = __webpack_public_path__ + "img/NoPlansAdded-Icon.c0738358.svg";